import { CellItem } from '@components/UI-Components/HierarchyWiseItemsTable/components/Row/Cell'
import ViewContext from '@modules/order/contexts/view-context'
import React, { FC, useContext } from 'react'
import get from 'lodash/result'
import last from 'lodash/last'
import { CentricTypography as Typography } from '@core/component/CentricTypography'
import formatNumberByLocale from '@utils/format-number-by-locale'
import HierarchyCell from '@modules/order/components/CellTemplates/components/HierarchyCell/HierarchyCell'
import FieldSkeleton from '@api/order/components/CellLoaders/FieldSkeleton'
import { KPIUIStore } from '@modules/order/stores/view/KPI/KPIUIStore'
import { CATEGORY_INTERNAL_SEPERATOR } from '@modules/order/constants/uiConstants'
import useOrderContext from '@modules/order/hooks/use-order-context'
import { nav } from '@stores'
import { OrderType } from '@api/common'

const EnhancedMixTarget: FC<CellItem> = ({ rowData, column }) => {
  const { uiStore } = useContext(ViewContext)
  const {
    uiStore: {
      dataStore: { summary }
    }
  } = useOrderContext()
  const { getHierarchy, getPlanningBudgetHeirarchy, getDoorWiseHierarchyKPIs } =
    uiStore as KPIUIStore
  if (!rowData) {
    return (
      <HierarchyCell>
        <FieldSkeleton />
      </HierarchyCell>
    )
  }
  const {
    queryParams: { orderType }
  } = nav
  let doorOrderDoorId = null
  if (orderType === OrderType.Door) {
    doorOrderDoorId = summary?.door?.id
  }
  const { enhancedField, targetMixField, doorId } = column
  const hierarchy = doorId
    ? getDoorWiseHierarchyKPIs(doorId, rowData?.name)
    : last(getHierarchy(rowData?.name))
  const isMainHeirarchy = !rowData?.name?.includes(CATEGORY_INTERNAL_SEPERATOR)
  const actualMix = Number(get(hierarchy, enhancedField) ?? 0)
  const planningBudgetHeirarchy =
    getPlanningBudgetHeirarchy(rowData?.name, doorId ?? doorOrderDoorId) ?? {}
  const targetMix = Number(get(planningBudgetHeirarchy, targetMixField) ?? 0)
  const value = `${formatNumberByLocale(actualMix, 2, 2)}% / ${formatNumberByLocale(
    targetMix,
    2,
    2
  )}%`
  return (
    <HierarchyCell>
      <Typography variant={isMainHeirarchy ? 'subtitle1' : 'caption'}>
        {value ?? '-'}
      </Typography>
    </HierarchyCell>
  )
}

export default EnhancedMixTarget
